import React from "react";
import { Typography } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import { RectangularTextButton } from "components/Base/Buttons";

interface FileUploaderProps {
  onFileSelect: (file: File) => void;
  selectedFile?: File | null;
}

const FileUploader: React.FC<FileUploaderProps> = ({
  onFileSelect,
  selectedFile,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) onFileSelect(file);
  };

  return (
    <Grid2 container alignItems="center">
      <Grid2 size={1} />

      <Grid2 size={2}>
        <RectangularTextButton
          colour="highlighted"
          component="label"
          fullWidth
        >
          Upload File (CSV / XLSX)
          <input
            type="file"
            accept=".csv,.xlsx,.xls"
            hidden
            onChange={handleChange}
          />
        </RectangularTextButton>
      </Grid2>

      <Grid2 size={2} />

      <Grid2 size={4}>
        {selectedFile && (
          <Typography variant="body1">
            Selected file: <strong>{selectedFile.name}</strong>
          </Typography>
        )}
      </Grid2>
    </Grid2>
  );
};

export default FileUploader;